/* eslint-disable */
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

// eslint-disable-next-line require-await
export async function getProductBreadcrumbs(productId: string): Promise<any> {
    const breadCrumbs = await get<any>(`api/v1/CustomBreadcrumbs/GetProductBreadcrumbs?productId=${productId}`, {} as ApiParameter);
    return breadCrumbs;
}
